module.exports = __webpack_public_path__ + "img/giftPacks.619fcfc5.png";